import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { MeetingEntity } from "../services/entities/meetingEntity";

interface FindColleagueState {
    meetingSelected: MeetingEntity | null;
    meetings: MeetingEntity[];
    textSearch: string;
    colleagueSelected: {
        name: string;
        email: string;
    } | null;

    setMeetingSelected: (meeting: MeetingEntity | null) => void;
    setMeetings: (meetings: MeetingEntity[]) => void;
    setTextSearch: (textSearch: string) => void;
    setColleagueSelected: (colleague: { name: string; email: string } | null) => void;
    clearFindColleague: () => void;
}

const initialState = {
    meetingSelected: null,
    meetings: [],
    colleagueSelected: null,
    textSearch: "",
};

export const useFindColleagueStore = create<FindColleagueState>()(
    devtools(
        (set) => ({
            ...initialState,

            setMeetingSelected: (meeting) => {
                set({ meetingSelected: meeting }, false, "setMeetingSelected");
            },

            setMeetings: (meetings) => {
                set({ meetings }, false, "setMeetings");
            },
            setTextSearch: (textSearch) => {
                set({ textSearch }, false, "setTextSearch");
            },
            setColleagueSelected: (colleague) => {
                set({ colleagueSelected: colleague }, false, "setColleagueSelected");
            },

            clearFindColleague: () => {
                set(initialState, false, "clearFindColleague");
            },
        }),
        {
            name: "find-colleague-store",
        }
    )
);

